import PropTypes from 'prop-types';

const propType = {
  _id: PropTypes.string,
  tenant: PropTypes.string,
  organization: PropTypes.string,
  name: PropTypes.string,
  manager: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.string),
};

export default { propType };
